
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/Common/configuration.service';
import { environment } from '@env/environment';
import { Injectable, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';


@Injectable()
export class AuthenticationEndpoint {


  private readonly login_Url: string = `${this.configurations.authenticationUrl}/connect/token`;
  private readonly _forgotPasswordUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/ForgotPassword`;
  private readonly _resetPasswordUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/ResetPassword`;
  private readonly _changePasswordUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/ChangePassword`;
  private readonly _getUserTenantMapUrl: string = ` ${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/getusertenantmap`;
  constructor(private http: HttpClient, private configurations: ConfigurationService) {
  }

  getLoginEndpoint<T>(userName: string, password: string, recaptcha?: string): Observable<T> {

    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    const params = new HttpParams()
      .append('username', userName)
      .append('password', password)
      .append('client_id', environment.clientId)
      .append('grant_type', 'password')
      .append('scope', 'openid email phone profile offline_access roles smart_app_web smartapp_api smarthealth_api smartlife_api iq2gateway IQ2GatewayAuthScheme')
      .append('recaptcha', recaptcha);


    return this.http.post<T>(this.login_Url, params, { headers: header });
  }

  forgotPasswordEndpoint<T>(obj: any): Observable<T> {
    var headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<T>(this._forgotPasswordUrl, JSON.stringify(obj), headers);
  }
  resetPasswordEndpoint<T>(obj: any): Observable<T> {
    var headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<T>(this._resetPasswordUrl, JSON.stringify(obj), headers);
  }
  validateResetPwdToken<T>(userId: string, token: string): Observable<any> {
    let endpointUrl = this._resetPasswordUrl + `? id = ${userId}& token=${token} `;
    var headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.get<T>(endpointUrl, headers);
  }
  getUserTenantMapEndpoint<T>(): Observable<T> {
    let endpointUrl = `${this._getUserTenantMapUrl} `;

    var headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.get<T>(endpointUrl, headers);
  }
  // getRefreshLoginEndpoint<T>(): Observable<T> {

  //   const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

  //   const params = new HttpParams()
  //   //   .append('refresh_token', this.authService.refreshToken) //TODO
  //     .append('client_id', environment.clientId)
  //     .append('grant_type', 'refresh_token')
  //     .append('scope', 'openid email phone profile offline_access roles');

  //   return this.http.post<T>(this.login_Url, params, { headers: header });
  // }

}
